import { render } from "./imgPublish.vue?vue&type=template&id=28188823&scoped=true"
import script from "./imgPublish.vue?vue&type=script&lang=js"
export * from "./imgPublish.vue?vue&type=script&lang=js"

import "./imgPublish.vue?vue&type=style&index=0&id=28188823&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28188823"]])

export default __exports__